import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "w-full h-[500px] bg-dark-secondary rounded-lg overflow-hidden" }
const _hoisted_3 = { class: "p-6 grid grid-cols-4 gap-4" }
const _hoisted_4 = { class: "absolute left-3 flex items-center pointer-events-none" }
const _hoisted_5 = ["placeholder"]

import { ref, onMounted, onUnmounted } from 'vue'

interface Props {
  customization: {
    appearance: {
      thread: {
        color: string
        background: string
        font: string
        linkColor: string
      }
      input: {
        color: string
        background: string
        size: string
        highlight: string
        placeholder: {
          text: string
          color: string
        }
      }
      cta: {
        background: string
      }
    }
    promptSuggestions: Array<{ value: string }>
    defaultFont: string
  }
  device: 'desktop' | 'tablet' | 'mobile'
}

const baseText = "Ask anything..."

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchWidgetPreview',
  props: {
    customization: {},
    device: {}
  },
  setup(__props: any) {

const props = __props

// Typewriter effect
const currentSuggestionIndex = ref(0)
const placeholder = ref(baseText)
const showSuggestions = ref(false)
let typewriterTimeout: number | undefined

const typeWriter = (text: string, isTyping = true, i = 0) => {
  if (isTyping) {
    if (i < text.length) {
      placeholder.value = baseText + text.substring(0, i + 1)
      typewriterTimeout = window.setTimeout(() => typeWriter(text, true, i + 1), 50)
    } else {
      typewriterTimeout = window.setTimeout(() => typeWriter(text, false, text.length), 1000)
    }
  } else {
    if (i > 0) {
      placeholder.value = baseText + text.substring(0, i - 1)
      typewriterTimeout = window.setTimeout(() => typeWriter(text, false, i - 1), 50)
    } else {
      currentSuggestionIndex.value = (currentSuggestionIndex.value + 1) % props.customization.promptSuggestions.length
      typewriterTimeout = window.setTimeout(
        () => typeWriter(props.customization.promptSuggestions[currentSuggestionIndex.value].value, true, 0),
        500
      )
    }
  }
}

const clearTypewriter = () => {
  if (typewriterTimeout) {
    window.clearTimeout(typewriterTimeout)
  }
  placeholder.value = baseText
}

onMounted(() => {
  typeWriter(props.customization.promptSuggestions[currentSuggestionIndex.value].value)
})

onUnmounted(() => {
  if (typewriterTimeout) {
    window.clearTimeout(typewriterTimeout)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"h-16 bg-dark border-b border-gray-700 flex items-center px-6\"><div class=\"w-32 h-4 bg-gray-700 rounded\"></div><div class=\"ml-auto flex items-center space-x-6\"><div class=\"w-16 h-4 bg-gray-700 rounded\"></div><div class=\"w-16 h-4 bg-gray-700 rounded\"></div><div class=\"w-16 h-4 bg-gray-700 rounded\"></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "aspect-square bg-dark rounded-lg"
          })
        }), 64))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute inset-0 bg-black/50", {
        'p-4': _ctx.device === 'mobile',
        'p-8': _ctx.device === 'tablet',
        'p-12': _ctx.device === 'desktop'
      }])
    }, [
      _createElementVNode("div", {
        class: "absolute left-0 right-0 bottom-4 mx-auto w-fit max-w-[90%] transition-all duration-200 hover:scale-[1.03] focus-within:hover:scale-100 group",
        style: _normalizeStyle({
          fontFamily: _ctx.customization.appearance.thread.font || 'sans-serif'
        })
      }, [
        _createElementVNode("div", {
          class: "relative flex items-center rounded-full backdrop-blur-2xl shadow-sm",
          style: _normalizeStyle({
            backgroundColor: _ctx.customization.appearance.input.background,
            borderColor: _ctx.customization.appearance.input.highlight,
            borderWidth: '1px'
          })
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("svg", {
              class: "w-4 h-4",
              style: _normalizeStyle({ color: _ctx.customization.appearance.input.placeholder.color }),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              }, null, -1)
            ]), 4))
          ]),
          _createElementVNode("input", {
            type: "text",
            placeholder: placeholder.value,
            class: "w-[300px] h-[2.3em] pl-10 pr-12 py-2 bg-transparent outline-none",
            style: _normalizeStyle({
              color: _ctx.customization.appearance.input.color,
              fontSize: _ctx.customization.appearance.input.size
            }),
            onFocus: _cache[0] || (_cache[0] = ($event: any) => {showSuggestions.value = true; clearTypewriter()}),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => {showSuggestions.value = false; typeWriter(_ctx.customization.promptSuggestions[currentSuggestionIndex.value].value)})
          }, null, 44, _hoisted_5),
          _createElementVNode("button", {
            class: "absolute right-2 w-8 h-8 flex items-center justify-center rounded-full transition-transform hover:scale-110",
            style: _normalizeStyle({
              backgroundColor: _ctx.customization.appearance.cta.background,
              color: '#ffffff'
            })
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 12h14m-7-7l7 7-7 7"
              })
            ], -1)
          ]), 4)
        ], 4),
        _createElementVNode("div", {
          class: _normalizeClass(["absolute bottom-full mb-2 left-0 right-0 border rounded-t-2xl overflow-hidden transition-all duration-300 transform origin-bottom", [
            showSuggestions.value ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
          ]]),
          style: _normalizeStyle({
            backgroundColor: _ctx.customization.appearance.input.background,
            borderColor: _ctx.customization.appearance.input.highlight,
            clipPath: showSuggestions.value ? 'inset(0 0 0 0)' : 'inset(100% 0 0 0)',
            paddingBottom: '1.5em'
          }),
          onMouseenter: clearTypewriter,
          onMouseleave: _cache[2] || (_cache[2] = () => !showSuggestions.value && typeWriter(_ctx.customization.promptSuggestions[currentSuggestionIndex.value].value))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customization.promptSuggestions, (suggestion, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "px-4 py-3 cursor-pointer transition-colors text-sm",
              style: _normalizeStyle({
              color: _ctx.customization.appearance.input.placeholder.color,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)'
              }
            })
            }, _toDisplayString(suggestion.value), 5))
          }), 128))
        ], 38)
      ], 4)
    ], 2)
  ]))
}
}

})